var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404NotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    x: 56,
    y: 64.087,
    fill: "#6556ff20",
    opacity: 1,
    rx: 200,
    "data-original": "#6556ff20",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M315.74 209.571c-1.2-19.112-2.075-33.036-12.151-42.021-5.646-5.035-12.342-6.877-20.722-7.47a6.226 6.226 0 0 1-5.767-6.218V137.68h-25.819v14.985a8.382 8.382 0 0 1-7.48 8.311c-10.165 1.144-18.692 3.74-25.265 10.118-3.878 3.763-11.095 12.741-9.113 61.765a485.146 485.146 0 0 0 7.594 67.84l90.088 1.553c1.418-11.851 3.585-30.09 6.2-52.736 2.138-18.456 3.195-27.929 2.435-39.945z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M307.1 303.251h-.017L217 301.7a1 1 0 0 1-.967-.82 488.385 488.385 0 0 1-7.609-67.979c-1.841-45.533 4.065-57.332 9.416-62.524 6.035-5.855 14.007-9.062 25.849-10.394a7.384 7.384 0 0 0 6.592-7.317V137.68a1 1 0 0 1 1-1H277.1a1 1 0 0 1 1 1v16.182a5.238 5.238 0 0 0 4.837 5.221c9.637.682 16.012 2.991 21.317 7.721 10.381 9.257 11.263 23.284 12.483 42.7v.007c.776 12.344-.365 22.21-2.436 40.123s-4.161 35.671-6.2 52.739a1 1 0 0 1-1.001.878zm-89.25-3.538 88.365 1.523c2.009-16.79 4.059-34.224 6.1-51.835 2.058-17.8 3.192-27.6 2.427-39.768v-.006c-1.19-18.938-2.051-32.621-11.818-41.33-4.947-4.412-10.967-6.571-20.127-7.219a7.245 7.245 0 0 1-6.7-7.216V138.68h-23.82v13.985a9.383 9.383 0 0 1-8.368 9.305c-11.372 1.28-18.984 4.315-24.681 9.842-2.967 2.879-10.85 10.528-8.81 61.007a486.16 486.16 0 0 0 7.436 66.894z",
    opacity: 1,
    "data-original": "#090817",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b297b",
    d: "M276.086 156.722a2356.64 2356.64 0 0 1 24.213 2.475c7 .751 10.617 1.172 14.428 3.628 6.206 4 8.342 10.568 9.451 12.826 20.626 41.979 45.7 52.136 41.176 76.278a24.419 24.419 0 0 1-4.05 10.463c-5.771 8.037-16.626 11.293-53.664 11.475a647.463 647.463 0 0 1-43.449-1.252l-2.369-21.277 52.4-14.682q-19.069-39.966-38.136-79.934z",
    opacity: 1,
    "data-original": "#6556ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b297b",
    d: "m246.634 152.724 33.414-1.092.59 5.8s25.23 4.035 30.8 16.139S323.165 290.4 323.165 290.4l-116.442-4.7s-5.379-97.675 0-107.253 25.229-16.979 38.392-20.509z",
    opacity: 1,
    "data-original": "#6556ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M306.965 104.85c.029-.379.065-.756.085-1.139a22.451 22.451 0 0 0 .055-5.121l-.116-.051a42.9 42.9 0 0 0-85.588-.121c-.04.059-.084.113-.125.172a55.787 55.787 0 0 0 .068 6.093 8.941 8.941 0 1 0 3.051 16.77c4.18 12.918 13.776 26.7 35.655 27.764 23.9 1.157 36.22-13.263 42.179-27.135a8.942 8.942 0 1 0 4.736-17.232z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M262.76 150.284q-1.354 0-2.758-.068c-22.313-1.079-32-15.247-36.2-27.394a9.944 9.944 0 1 1-3.586-19.218h.076c-.132-3.076-.016-4.988-.011-5.078a1.006 1.006 0 0 1 .147-.461 43.9 43.9 0 0 1 87.532 0 1.017 1.017 0 0 1 .134.359 23.187 23.187 0 0 1-.046 5.381c0 .094-.011.2-.019.3a9.942 9.942 0 0 1-5.224 19.156c-5.644 12.657-17.105 27.021-40.045 27.023zm-38.36-29.831a1 1 0 0 1 .952.692c3.807 11.768 12.926 26.018 34.751 27.073 24.174 1.17 35.736-13.783 41.212-26.53a1 1 0 0 1 1.218-.56 7.941 7.941 0 1 0 4.208-15.3 1 1 0 0 1-.768-1.048l.031-.387c.02-.243.04-.484.052-.728a25.405 25.405 0 0 0 .113-4.557 1.006 1.006 0 0 1-.173-.5 41.9 41.9 0 0 0-83.596-.118 1 1 0 0 1-.138.439c-.03.72-.088 2.8.082 5.7a1 1 0 0 1-1.124 1.051 7.87 7.87 0 0 0-1.006-.072 7.945 7.945 0 0 0 0 15.889 7.849 7.849 0 0 0 3.714-.924 1 1 0 0 1 .472-.12z",
    opacity: 1,
    "data-original": "#090817",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M289.933 100.923a1 1 0 0 1-.508-.139 15.994 15.994 0 0 0-16.588-.231 1 1 0 0 1-1.108-1.665 17.983 17.983 0 0 1 18.713.174 1 1 0 0 1-.509 1.861z",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.35,
    cy: 112.715,
    r: 4.442,
    fill: "#923d91",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M233.887 99.806a1 1 0 0 1-.64-1.768 14.987 14.987 0 0 1 16.568-1.755 1 1 0 0 1-.929 1.771 12.985 12.985 0 0 0-14.36 1.521 1 1 0 0 1-.639.231z",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 243.606,
    cy: 113.655,
    r: 4.442,
    fill: "#923d91",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M260.711 122.717c-1.775 0-3.777-.279-4.6-1.414-1.242-1.72.958-8.815 2.38-12.891a1 1 0 0 1 1.889.659c-1.6 4.575-3.029 10.129-2.621 11.105.375.512 3.013.7 5.51.357a1 1 0 1 1 .276 1.98 21.217 21.217 0 0 1-2.834.204z",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.026,
    cy: 121.614,
    fill: "#1b297b",
    rx: 6.137,
    ry: 4.006,
    transform: "rotate(-4.01 286.323 122.115)",
    opacity: 1,
    "data-original": "#6556ff",
    className: ""
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 240.099,
    cy: 123.663,
    fill: "#1b297b",
    rx: 6.137,
    ry: 4.006,
    transform: "rotate(-4.01 241.193 124.177)",
    opacity: 1,
    "data-original": "#6556ff",
    className: ""
  }), /*#__PURE__*/React.createElement("rect", {
    width: 328.063,
    height: 193.635,
    x: 91.968,
    y: 272.615,
    fill: "#ffffff",
    rx: 13.758,
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M406.273 467.25H105.726a14.775 14.775 0 0 1-14.758-14.758V286.373a14.774 14.774 0 0 1 14.758-14.758h300.547a14.774 14.774 0 0 1 14.758 14.758v166.119a14.775 14.775 0 0 1-14.758 14.758zM105.726 273.615a12.772 12.772 0 0 0-12.758 12.758v166.119a12.773 12.773 0 0 0 12.758 12.758h300.547a12.772 12.772 0 0 0 12.758-12.758V286.373a12.772 12.772 0 0 0-12.758-12.758z",
    opacity: 1,
    "data-original": "#090817",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1b297b",
    d: "M246.212 159.831a62.6 62.6 0 0 0-22.613 3.163c-12.872 4.362-20.56 11.9-28.351 19.238-33.359 31.4-35.366 27.662-40.5 35.945-19.748 31.839 11.752 84.063 17.717 93.66l25.82-7.594-14.85-61.09a246.876 246.876 0 0 0 33.076-20.25c20.736-15.077 33.563-24.682 35.439-39.658 1.235-9.865-2.741-18.381-5.738-23.414z",
    opacity: 1,
    "data-original": "#6556ff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M241.619 126.357A13.361 13.361 0 1 1 254.98 113a13.376 13.376 0 0 1-13.361 13.357zm0-23.722A10.361 10.361 0 1 0 251.98 113a10.373 10.373 0 0 0-10.361-10.365zM278.9 126.357A13.361 13.361 0 1 1 292.259 113a13.376 13.376 0 0 1-13.359 13.357zm0-23.722A10.361 10.361 0 1 0 289.259 113a10.373 10.373 0 0 0-10.359-10.365z",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M267.036 114.5H253.48a1.5 1.5 0 0 1 0-3h13.556a1.5 1.5 0 0 1 0 3zM263.383 137.32a8.08 8.08 0 0 1-6.444-3.045 1 1 0 0 1 .156-1.405c.3-.244 7.485-5.908 12.5-2.951a2.7 2.7 0 0 1 1.533 2.755c-.229 1.747-2.3 3.5-5.024 4.262a10.106 10.106 0 0 1-2.721.384zm-4.158-3.524a6.726 6.726 0 0 0 6.337 1.214c2.078-.58 3.475-1.8 3.58-2.6.014-.111.053-.407-.566-.772-2.976-1.752-7.468.877-9.351 2.162z",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M205.639 231.36h-.026a1 1 0 0 1-.974-1.026L205.755 187a.962.962 0 0 1 1.026-.974 1 1 0 0 1 .973 1.026l-1.116 43.334a1 1 0 0 1-.999.974zM279.661 250.9a1 1 0 0 1-.2-1.981l53.205-10.69c.036-.006.071-.012.107-.015.459-.041 11.36-.97 21.256 2.739a1 1 0 0 1-.7 1.873c-9.124-3.421-19.508-2.688-20.322-2.624l-53.149 10.678a1.023 1.023 0 0 1-.197.02z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M316.671 243.468a1 1 0 0 1-1-.943l-3.2-55.442a1 1 0 1 1 2-.115l3.2 55.442a1 1 0 0 1-.941 1.056zM183.762 245.5a1 1 0 0 1-.915-.595c-3.674-8.279-12.931-10.275-13.024-10.294a1 1 0 0 1 .4-1.96c.421.086 10.352 2.2 14.452 11.443a1 1 0 0 1-.913 1.406z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M221.045 118.293a.991.991 0 0 1-.479-.123 4.256 4.256 0 0 1-2.383-3.076 5.558 5.558 0 0 1 .7-3.385l-2.672.431a1 1 0 0 1-.317-1.975l4.993-.8a1 1 0 0 1 .888 1.672c-.525.565-1.844 2.343-1.616 3.749a2.339 2.339 0 0 0 1.366 1.634 1 1 0 0 1-.48 1.877zM304.554 119.613a1 1 0 0 1-.5-1.864 3.331 3.331 0 0 0 1.788-2.185 5.185 5.185 0 0 0-.992-3.523 1 1 0 0 1 .723-1.6l4.649-.344a.983.983 0 0 1 1.071.923 1 1 0 0 1-.923 1.071l-3.08.228a6.14 6.14 0 0 1 .516 3.627 5.278 5.278 0 0 1-2.746 3.531 1 1 0 0 1-.506.136zM161.693 324.922s-36.166 66.633-35.594 69.466 48.74-4.532 49.634-3.576 1.815 33.5 3.779 34.6 24.831-1.658 25.966-5.732-13.138-98.613-16.284-100.9-27.501 6.142-27.501 6.142zm10.81 46.537c-1.232 1.153-16.571 2.149-17.95 1.96s12.841-30.091 12.841-30.091 6.341 26.978 5.106 28.131zM378.511 320.934c-2.879-2.618-28.005 3.119-28.005 3.119s-43.185 62.313-42.924 65.192 48.944.785 49.729 1.832-1.832 33.5 0 34.81 24.864 1.047 26.435-2.879-2.356-99.457-5.235-102.074zm-19.063 50.555c-1.35 1.012-16.707.337-18.057 0s16.032-28.52 16.032-28.52 3.377 27.507 2.025 28.52zM256 321.764c-22.592 0-40.907 23.467-40.907 52.416S233.408 426.6 256 426.6s40.907-23.467 40.907-52.415-18.315-52.421-40.907-52.421zm.087 82.3c-12.862 0-23.289-13.676-23.289-30.545s10.427-30.545 23.289-30.545 23.288 13.675 23.288 30.545-10.426 30.54-23.288 30.54z",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M171.443 306.076s-9.377 14.08-12.354 18.607-6.554 14.753-4.444 15.348 5.684-5.422 5.684-5.422-3.877 13.155-.179 13.848 4.738-9.63 4.738-9.63 2.232 11.958 4.81 11.47 4-12.317 4-12.317 1.385 12.053 5.151 11.112 2.245-15.06 4.152-17.378 8.2-10.087 9.263-9.784-1.649 12.02 2.525 11.4 3.173-9.494 6.37-14.935-4.354-19.148-6.952-20.606-18.779-.21-22.764 8.287z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M169.545 351.311a2.017 2.017 0 0 1-1.152-.377c-1.432-.979-2.607-4.265-3.4-7.183-.555 2.036-1.417 4.148-2.72 5.124a2.886 2.886 0 0 1-2.3.564 2.5 2.5 0 0 1-1.7-1.21c-1.13-1.845-.7-5.8-.077-9.038-1.208 1.252-2.572 2.154-3.818 1.8a1.76 1.76 0 0 1-1.164-1.135c-1.022-2.739 2.419-11.738 5.042-15.725 2.864-4.354 11.649-17.547 12.317-18.55 2.06-4.31 6.785-6.594 10.4-7.752 5.592-1.794 11.858-1.963 13.724-.914 2.028 1.137 5.985 7.708 7.543 13.47 1 3.7.927 6.566-.217 8.514a25.146 25.146 0 0 0-2.369 7.426c-.818 3.87-1.591 7.526-4.717 7.991a2.547 2.547 0 0 1-2.16-.613c-1.55-1.408-1.519-4.558-1.315-8.529.027-.54.058-1.146.069-1.655a93.171 93.171 0 0 0-7.39 8.382l-.366.446c-.574.7-.8 3.884-.987 6.444-.373 5.179-.758 10.535-3.7 11.269a2.689 2.689 0 0 1-2.237-.435c-1.434-.993-2.423-3.473-3.076-5.889-1.356 6.292-3.094 7.391-3.89 7.541a1.8 1.8 0 0 1-.34.034zm-4.657-13.484a1 1 0 0 1 .983.817c1 5.365 2.735 10.352 3.709 10.672.92-.333 2.442-5.793 3.12-11.455a1 1 0 0 1 .993-.881 1 1 0 0 1 .992.886c.378 3.29 1.61 8.946 3.3 10.117a.694.694 0 0 0 .614.139c1.53-.383 1.939-6.073 2.184-9.472.284-3.957.506-6.44 1.437-7.571l.364-.445c7.755-9.451 8.932-9.951 9.946-9.665 1.122.32 1.058 1.57.919 4.309-.108 2.119-.31 6.063.663 6.946a.559.559 0 0 0 .521.116c1.751-.26 2.355-3.118 3.054-6.426a27 27 0 0 1 2.6-8.026c.851-1.447.854-3.86.011-6.979-1.547-5.721-5.3-11.525-6.59-12.248-1.1-.616-6.677-.678-12.135 1.074-3.252 1.043-7.493 3.063-9.23 6.766a.91.91 0 0 1-.073.129s-9.375 14.077-12.351 18.6c-3.006 4.57-5.364 12.338-4.876 13.842.754-.1 2.766-2.192 4.421-4.976a1 1 0 0 1 1.82.794c-1.111 3.769-2.449 10.44-1.313 12.293a.519.519 0 0 0 .358.289.884.884 0 0 0 .738-.2c1.541-1.153 2.548-5.855 2.821-8.547a1 1 0 0 1 .953-.9z",
    opacity: 1,
    "data-original": "#090817",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M257.378 262.394s-20.616 2.74-19.73 4.765 7.341 5.189 12.277 4.683a23.416 23.416 0 0 0 9.492-3.671z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M248.876 272.893c-4.935 0-11.081-2.9-12.144-5.333a1.341 1.341 0 0 1 .069-1.2c1.186-2.1 13.319-4.006 20.445-4.954a1 1 0 0 1 1.075.659l2.039 5.777a1 1 0 0 1-.373 1.155 24.215 24.215 0 0 1-9.96 3.843 11.1 11.1 0 0 1-1.151.053zm-10.034-5.728c1.359 1.526 6.644 4.125 10.981 3.682a21.726 21.726 0 0 0 8.387-3.09l-1.5-4.263c-7.563 1.037-15.91 2.631-17.868 3.671z",
    opacity: 1,
    "data-original": "#090817",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M262.608 258.966s-13.088 8.294-16.261 11.827-5.077 24.423-3.173 25.959 6.346-10.138 6.346-10.138-.522 13.21 2.991 13.671S257.135 288 257.135 288s1.11 12.466 3.648 12.3 3.636-14.758 3.636-14.758 2.076 12.288 4.3 11.213 1.586-15.039 3.648-17.12 12.851-3.463 16.658-6.074 4.442-8.755 4.442-8.755l-13.8-14.9z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M260.738 301.3c-1.788 0-2.939-2.868-3.68-6.509-.592 2.459-1.472 4.883-2.743 5.9a2.512 2.512 0 0 1-1.934.583c-2.778-.364-3.624-5.464-3.839-9.745-1.36 2.919-3.073 5.9-4.542 6.3a1.6 1.6 0 0 1-1.454-.3c-.588-.475-.9-1.452-1.047-3.267-.475-5.915 1.126-20.822 4.1-24.138 3.228-3.594 15.93-11.662 16.469-12a.726.726 0 0 1 .067-.038l17.054-9.062a1 1 0 0 1 1.2.2l13.8 14.9a1 1 0 0 1 .262.782c-.028.27-.73 6.637-4.871 9.478-2.061 1.413-5.782 2.424-9.381 3.4-2.953.8-6.3 1.711-7.133 2.551-.747.754-1.149 4.916-1.443 7.955-.528 5.468-.9 8.6-2.48 9.361a1.628 1.628 0 0 1-1.489-.027c-1.183-.611-2.164-3.1-2.9-5.774-.716 5.01-1.912 9.313-3.912 9.444-.03.006-.068.006-.104.006zm-11.218-15.686a.978.978 0 0 1 .2.021 1 1 0 0 1 .8 1.019c-.285 7.247.89 12.477 2.122 12.639.058.008.191.026.421-.159 1.642-1.319 2.759-7.585 3.077-11.224a1 1 0 0 1 1-.913 1 1 0 0 1 1 .911c.482 5.411 1.667 10.564 2.583 11.339.987-.954 2.206-7.109 2.708-13.783a1 1 0 0 1 1.983-.091c.818 4.837 2.14 9.34 3 10.321.6-.987.992-5.084 1.236-7.6.475-4.921.848-7.994 2.013-9.17 1.211-1.221 4.37-2.079 8.029-3.073 3.277-.891 6.993-1.9 8.774-3.122 2.834-1.944 3.731-6.223 3.951-7.6l-12.957-13.987-16.34 8.683c-.719.457-13.049 8.323-16.02 11.63-1.2 1.332-2.478 6.451-3.192 12.737-.684 6.023-.547 10.269-.167 11.532 1.043-.918 3.15-5 4.853-9.472a1 1 0 0 1 .926-.638z",
    opacity: 1,
    "data-original": "#090817",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M262.608 258.966s-13.088 8.294-16.261 11.827-5.077 24.423-3.173 25.959 6.346-10.138 6.346-10.138-.522 13.21 2.991 13.671S257.135 288 257.135 288s1.11 12.466 3.648 12.3 3.636-14.758 3.636-14.758 2.076 12.288 4.3 11.213 1.586-15.039 3.648-17.12 12.851-3.463 16.658-6.074 4.442-8.755 4.442-8.755l-13.8-14.9z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M260.738 301.3c-1.788 0-2.939-2.868-3.68-6.509-.592 2.459-1.472 4.883-2.743 5.9a2.512 2.512 0 0 1-1.934.583c-2.778-.364-3.624-5.464-3.839-9.745-1.36 2.919-3.073 5.9-4.542 6.3a1.6 1.6 0 0 1-1.454-.3c-.588-.475-.9-1.452-1.047-3.267-.475-5.915 1.126-20.822 4.1-24.138 3.228-3.594 15.93-11.662 16.469-12a.726.726 0 0 1 .067-.038l17.054-9.062a1 1 0 0 1 1.2.2l13.8 14.9a1 1 0 0 1 .262.782c-.028.27-.73 6.637-4.871 9.478-2.061 1.413-5.782 2.424-9.381 3.4-2.953.8-6.3 1.711-7.133 2.551-.747.754-1.149 4.916-1.443 7.955-.528 5.468-.9 8.6-2.48 9.361a1.628 1.628 0 0 1-1.489-.027c-1.183-.611-2.164-3.1-2.9-5.774-.716 5.01-1.912 9.313-3.912 9.444-.03.006-.068.006-.104.006zm-11.218-15.686a.978.978 0 0 1 .2.021 1 1 0 0 1 .8 1.019c-.285 7.247.89 12.477 2.122 12.639.058.008.191.026.421-.159 1.642-1.319 2.759-7.585 3.077-11.224a1 1 0 0 1 1-.913 1 1 0 0 1 1 .911c.482 5.411 1.667 10.564 2.583 11.339.987-.954 2.206-7.109 2.708-13.783a1 1 0 0 1 1.983-.091c.818 4.837 2.14 9.34 3 10.321.6-.987.992-5.084 1.236-7.6.475-4.921.848-7.994 2.013-9.17 1.211-1.221 4.37-2.079 8.029-3.073 3.277-.891 6.993-1.9 8.774-3.122 2.834-1.944 3.731-6.223 3.951-7.6l-12.957-13.987-16.34 8.683c-.719.457-13.049 8.323-16.02 11.63-1.2 1.332-2.478 6.451-3.192 12.737-.684 6.023-.547 10.269-.167 11.532 1.043-.918 3.15-5 4.853-9.472a1 1 0 0 1 .926-.638z",
    opacity: 1,
    "data-original": "#090817",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#923d91",
    d: "M216.906 105.238s2.552-.782 3.853.9 1.951 4.553 4.821 3.52-.547-26.171 13.157-36.961c0 0-1.9 10.79 8.886 5.05s24-11.512 33.47-10.79c0 0 15.425 13.7 17.606 21.429s.688 19.666 4.591 20.354 4.163-2.817 6.042-2.958 2.9 2.638 2.9 2.638 2.2-13.149 1.622-18.658c0 0 2.482 2.912 4.165-1.376s-9.948-22.5-15.917-24.03c0 0 7.04 2.3 6.887-1.531s-14.08-10.1-20.049-9.03c0 0-12.4-9.03-18.672-7.958s-2.724 4.591-2.724 4.591-20.091-1.377-28.809 2.3-4.765 8.571-4.765 8.571-14.208 6.887-18.493 12.243 1.989 6.582 1.989 6.582-2.806 12.887-.56 25.114z",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M224.661 83.341a.989.989 0 0 1-.558-.171 1 1 0 0 1-.27-1.388c.3-.442 7.39-10.855 16.519-14.6a1 1 0 0 1 1.37 1.06c-.124.923-.206 3.739 1.006 4.553.977.655 2.741-.1 4.049-.849a1 1 0 1 1 1 1.735c-2.622 1.5-4.695 1.762-6.164.772-1.566-1.057-1.921-3.208-1.956-4.752-7.882 3.988-14.1 13.1-14.161 13.2a1 1 0 0 1-.835.44zM308.471 82.483h-.156c-2.321-.121-5.667-3.105-7.8-5.27a4.293 4.293 0 0 1-.77 2.253 2.307 2.307 0 0 1-1.741.893h-.074c-2.587 0-7.5-6.5-9.515-9.316a1 1 0 0 1 1.629-1.162c3.242 4.545 6.846 8.427 7.868 8.478a.318.318 0 0 0 .266-.137c.481-.608.42-2.45.227-3.5a1 1 0 0 1 1.736-.839c2.192 2.5 6.378 6.507 8.28 6.606.246.014.3-.053.332-.08a.923.923 0 0 0 .31-.732c0-1.536-2.186-3.919-2.953-4.632a1 1 0 0 1 1.364-1.464c.367.342 3.591 3.422 3.589 6.1a2.927 2.927 0 0 1-.951 2.2 2.358 2.358 0 0 1-1.641.602zM243.606 57.17a1 1 0 0 1-.28-1.961c.377-.109 9.3-2.683 16.811-2.1a1 1 0 1 1-.155 1.994c-7.144-.554-16.006 2-16.1 2.029a.98.98 0 0 1-.276.038zM304.553 99.647a1 1 0 0 1-1-1 52.9 52.9 0 0 0-1.8-11.9 1 1 0 1 1 1.926-.54 54 54 0 0 1 1.874 12.444 1 1 0 0 1-1 .996z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#080717"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.982 336.881a1.011 1.011 0 0 1-.336-.058 1 1 0 0 1-.606-1.279c.119-.333 2.972-8.226 7.652-13.219a1 1 0 0 1 1.459 1.368c-4.4 4.692-7.2 12.447-7.227 12.524a1 1 0 0 1-.942.664zM166.134 345.082a1 1 0 0 1-.955-.707 21.3 21.3 0 0 1 0-11.165 21.984 21.984 0 0 1 4.829-8.8 1 1 0 0 1 1.414 1.414 20.389 20.389 0 0 0-4.325 7.955 19.6 19.6 0 0 0 0 10.015 1 1 0 0 1-.665 1.248 1.024 1.024 0 0 1-.298.04zM173.691 338.98a1 1 0 0 1-.989-.869c-.044-.333-1.044-8.206 1.621-12.809a1 1 0 0 1 1.731 1c-2.328 4.021-1.38 11.47-1.37 11.545a1 1 0 0 1-.993 1.131zM248.52 290.071a1.055 1.055 0 0 1-.215-.023 1 1 0 0 1-.763-1.191c.258-1.181 2.559-11.594 3.8-13.526a36.722 36.722 0 0 1 4.794-5.14 1 1 0 0 1 1.338 1.487 35.749 35.749 0 0 0-4.448 4.732c-.787 1.228-2.582 8.548-3.527 12.875a1 1 0 0 1-.979.786zM257.4 291.4a1 1 0 0 1-.993-.9c-.035-.33-.842-8.119-.606-10.6.249-2.608 3.7-7.415 4.09-7.954a1 1 0 1 1 1.617 1.176c-1.358 1.868-3.568 5.412-3.716 6.967-.217 2.285.6 10.126.6 10.2a1 1 0 0 1-.89 1.1c-.027.011-.063.011-.102.011zM264.491 289.033a1 1 0 0 1-1-.922c-.019-.244-.465-6.019.019-8.315.479-2.278 3.253-6.948 3.568-7.473a1 1 0 1 1 1.715 1.029c-.807 1.346-2.979 5.2-3.326 6.856a42.01 42.01 0 0 0 .018 7.747 1 1 0 0 1-.919 1.075.853.853 0 0 1-.075.003z",
    fill: "#923d91",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 113.395,
    cy: 292.187,
    r: 10.713,
    fill: "#923d91",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M121.354 293.187h-16.223a1 1 0 1 1 0-2h16.223a1 1 0 0 1 0 2z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 113.395,
    cy: 446.214,
    r: 10.713,
    fill: "#923d91",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M119.023 452.841a.993.993 0 0 1-.707-.293l-11.472-11.471a1 1 0 1 1 1.414-1.414l11.472 11.471a1 1 0 0 1-.707 1.707z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.372,
    cy: 446.214,
    r: 10.713,
    fill: "#923d91",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M406.637 447.213h-16.224a1 1 0 0 1 0-2h16.224a1 1 0 0 1 0 2z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 398.372,
    cy: 292.187,
    r: 10.713,
    fill: "#923d91",
    opacity: 1,
    "data-original": "#080717",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M404.216 299.031a1 1 0 0 1-.707-.293l-11.472-11.471a1 1 0 0 1 1.414-1.414l11.472 11.471a1 1 0 0 1-.707 1.707z",
    opacity: 1,
    "data-original": "#ffffff",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404NotFound);
export default __webpack_public_path__ + "static/media/404NotFound.f605953611e26fc1865098033aba6164.svg";
export { ForwardRef as ReactComponent };